const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Helper function to create fetch with timeout
const fetchWithTimeout = async (url, options = {}, timeout = 10000) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    throw error;
  }
};

/* ==== Lead Management ==== */

export const createLead = async (leadData) => {
  try {
    const response = await fetchWithTimeout(`${API_BASE_URL}/leads/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(leadData),
    }, 15000); // 15 second timeout

    const responseData = await response.json();

    if (response.status === 201) {
      return { success: true, data: responseData };
    } else if (response.status === 400) {
      return { success: false, message: responseData.error || 'Invalid input. Please check the data and try again.' };
    } else if (response.status === 409) {
      return { success: false, message: 'A lead with this email already exists. Please use another email.' };
    } else {
      return { success: false, message: responseData.error || 'An unexpected error occurred. Please try again.' };
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      return { success: false, message: 'Request timeout. Please check your connection and try again.' };
    }
    return { success: false, message: `Error: ${error.message}` };
  }
};

export const getLeads = async () => {
  try {
    const response = await fetchWithTimeout(`${API_BASE_URL}/leads/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }, 10000); // 10 second timeout

    const responseData = await response.json();

    if (response.status === 200) {
      return { success: true, data: responseData };
    } else if (response.status === 401) {
      return { success: false, message: 'Unauthorized. Please log in to view leads.' };
    } else if (response.status === 403) {
      return { success: false, message: 'Access denied. You do not have permission to view leads.' };
    } else {
      return { success: false, message: responseData.error || 'An unexpected error occurred. Please try again.' };
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      return { success: false, message: 'Request timeout. Please check your connection and try again.' };
    }
    return { success: false, message: `Error: ${error.message}` };
  }
};
